<template>
	<div style="overflow-y: auto; min-height: 100vh">
		<v-container>
			<v-row justify="center">
				<v-col cols="12">
					<v-skeleton-loader :loading="loading" height="94" type="list-item-two-line">
						<place-list
							title="Clientes"
							msjnodata="No hay establecimientos para mostrar"
							:chipsList="chipsList"
							:myOwnedPlaces="myOwnedPlaces"
							:mySharedPlaces="mySharedPlaces"
							:empresaPlaces="empresaPlaces"
							:domicilioPlaces="domicilioPlaces"
							:onChangeChips="onChangeChips"
							:places="placeListFilter"
							:set-filter="e => filter(e)"
							:warningMessage="warningMessage"
						>
							<template v-slot:top-actions>
								<place-form-dialog />
								<v-btn
									icon
									class="ma-2"
									@click="
										() => {
											fetchPlace();
											getLodgingsOfAdmin();
										}
									"
								>
									<v-icon>mdi-reload</v-icon>
								</v-btn>
							</template>
						</place-list>
					</v-skeleton-loader>
				</v-col>
			</v-row>
		</v-container>
		<!-- Fuera del v-container: el gestor se centra en su propia caja de
		     1500px, igual que en certplag, en vez de quedar limitado a 1185px -->
		<v-container fluid class="py-0">
			<list-work-order />
		</v-container>
	</div>
</template>

<script>
import filterDocumentMixin from '@/mixins/filterDocument.js';
import moment from 'moment';
import { isArray } from 'lodash';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
	name: 'Place',
	components: {
		PlaceList: () => import('@/components/place/PlaceList.vue'),
		PlaceFormDialog: () => import('@/components/place/PlaceFormDialog'),
		ListWorkOrder: () => import('@/components/place/ListWorkOrder.vue'),
	},
	mixins: [filterDocumentMixin],
	data() {
		return {
			placeListFilter: [],
			warningMessage: '',
			form: {
				name: '',
				rut: '',
				services: [],
			},
		};
	},
	computed: {
		chipsList() {
			return this.getLabelsPlaces(this.places);
		},
		myOwnedPlaces() {
			return this.placeListFilter.filter(
				place => place.ownerEmail === this.userProfile.email
			);
		},
		mySharedPlaces() {
			return this.placeListFilter.filter(
				place => place.ownerEmail !== this.userProfile.email
			);
		},
		domicilioPlaces() {
			return this.placeListFilter.filter(place => place.type === 'Domicilio');
		},
		empresaPlaces() {
			return this.placeListFilter.filter(place => place.type === 'Empresa');
		},
		...mapGetters({
			loading: 'User/globalLoading',
			places: 'Place/placesFiltered',
			message: 'Place/message',
			month: 'Lodging/month',
		}),
	},
	watch: {
		message(newVal) {
			this.snackbar({
				content: newVal.text,
				color: newVal.type,
			});
		},
		places(newVal) {
			this.placeListFilter = newVal;
		},
		month() {
			this.getLodgingsOfAdmin();
		},
	},
	mounted() {
		this.placeListFilter = this.places;
	},
	methods: {
		itsDue(date) {
			return moment(date).isBefore(moment().format());
		},
		filter(word) {
			if (isArray(word)) {
				// filter place by documents
				const labelDefaultSelected = this.labelDefaultSelected(word);
				this.placeListFilter = this.places.filter(place => {
					return place.typeDocuments.some(typeDocument => {
						if (typeDocument) {
							const status =
								word.includes(typeDocument.done ? 'subido' : 'pendiente') ||
								word.includes(this.itsDue(typeDocument.date) && 'caducado');
							const text = word.some(
								item => typeDocument.text.toLowerCase().indexOf(item) > -1
							);
							if (labelDefaultSelected) return status && text;
							return text;
						}
					});
				});
			} else {
				this.placeListFilter = this.places.filter(
					place =>
						place.name.toLowerCase().indexOf(word.toLowerCase()) > -1 ||
						place.rut.toLowerCase().indexOf(word.toLowerCase()) > -1 ||
						place.direction.toLowerCase().indexOf(word.toLowerCase()) > -1 ||
						place.type.toLowerCase().indexOf(word.toLowerCase()) > -1
				);
			}
		},
		onChangeChips(labels) {
			// clear warning message
			this.warningMessage = '';
			// return to the original state places
			if (!labels.length) return (this.placeListFilter = this.places);
			// set warning message if empty document selected
			if (!this.labelSelected(labels))
				return (this.warningMessage = 'Falta seleccionar el documento a filtrar');
			this.filter(labels);
		},
		...mapActions({
			fetchPlace: 'Lodging/fetchPlace',
			getLodgingsOfAdmin: 'Lodging/getLodgingsOfAdmin',
		}),
		...mapMutations({
			snackbar: 'Snackbar/showMessage',
		}),
	},
};
</script>

<style lang="scss">
.center {
	display: block;
	margin-left: auto;
	margin-right: auto;
}
</style>
